module.exports = __webpack_public_path__ + "img/baseline-picture_as_pdf-24px.76a939e5.svg";